// extracted by mini-css-extract-plugin
export default {"date":"PostDate_date__1GE9E"};